'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var pagination = require('./pagination.js');
var button = require('./button.js');
var parts = ['container', 'text', 'arrow'];
var baseStyleText = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  mb: 1
};
var baseStyle = function baseStyle(props) {
  var paginationStyles = pagination["default"].baseStyle(props);
  return {
    container: paginationStyles.container,
    text: baseStyleText,
    arrow: paginationStyles.arrow
  };
};
var sizes = {
  sm: {
    text: {
      fontSize: button["default"].sizes.sm.fontSize
    },
    arrow: button["default"].sizes.sm
  },
  md: {
    text: {
      fontSize: button["default"].sizes.md.fontSize
    },
    arrow: button["default"].sizes.md
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
var CompactPagination = {
  parts: parts,
  sizes: sizes,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
exports["default"] = CompactPagination;